/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/button-has-type */
// Copyright (c) 2016 Deere & Company

import './dealer-search-header.scss';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

const DealerSearchHeader = (props) => (
    <section className="dealer-search-header">
        <div className="dealer-search-label">
            <FormattedMessage id="DEALER_SEARCH" />
        </div>
        <div className="dealer-search-button-group">
            <button
                className="button-primary"
                auth={props.auth}
                onClick={props.onDealerSearchClick}
            >
                <FormattedMessage id="SEARCH" />
            </button>
            <span className="cancel-dealer-search" />
        </div>
    </section>
);

DealerSearchHeader.displayName = 'DealerSearchHeader';
DealerSearchHeader.propTypes = {
    auth: PropTypes.object,
    onDealerSearchClick: PropTypes.func.isRequired,
};

export default DealerSearchHeader;
